var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/Rx';
import { HttpClientWrapper } from './httpClient';
import { SharedService } from './shared.service';
var UuidService = (function (_super) {
    __extends(UuidService, _super);
    function UuidService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        return _this;
    }
    UuidService.prototype.findUuid = function (codigo) {
        var wsUrl = this.urlPublic() + "uuid/" + codigo;
        return this._http.getPublic(wsUrl)
            .map(function (response) { return response.json(); });
    };
    UuidService.prototype.findActuacion = function (codigo) {
        var wsUrl;
        wsUrl = this.urlPublic() + "uuid/actuacion/" + codigo;
        return this._http.getPublic(wsUrl)
            .map(function (response) { return response.json(); });
    };
    UuidService.prototype.adjuntosAct = function (codigo) {
        var wsUrl;
        wsUrl = this.urlPublic() + "uuid/adjuntos/" + codigo + "/iurix";
        return this._http.getPublic(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/zip' });
        });
    };
    UuidService.prototype.findTextoAct = function (codigo, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 10; }
        var wsUrl;
        wsUrl = this.urlPublic() + "uuid/" + codigo + "/textoact?page=" + page + "&size=" + size;
        return this._http.getPublic(wsUrl)
            .map(function (response) { return response.json(); });
    };
    UuidService.prototype.findVideoActPath = function (ticket) {
        var wsUrl;
        wsUrl = this.urlPublic() + "uuid/getvideo/" + ticket;
        return wsUrl;
    };
    UuidService.prototype.getPdfAct = function (codigo) {
        var wsUrl;
        wsUrl = this.urlPublic() + "uuid/pdf/" + codigo;
        var headers = new Headers({
            'Content-Type': 'application/json',
        });
        var options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this._http.getPublic(wsUrl, options)
            .map(function (response) {
            var fileBlob = response._body;
            var blob = new Blob([fileBlob], {
                type: 'application/pdf'
            });
            return blob;
        });
    };
    UuidService.prototype.getPdfPki = function (codigo) {
        var wsUrl;
        wsUrl = this.urlPublic() + "/uuid/pkipdf/" + codigo + "/iurix";
        return this._http.getPublic(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/zip' });
        });
    };
    return UuidService;
}(SharedService));
UuidService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClientWrapper])
], UuidService);
export { UuidService };
//# sourceMappingURL=uuid.service.js.map